export const letterSpacings = (rtl: boolean) => ({
	letterSpacings: {
		wide: rtl ? "0" : ".01em",
		wider: rtl ? "0" : ".02em",
		widest: rtl ? "0" : ".03em",
		superWide: rtl ? "0" : ".07em"
	}
})